import React from 'react'

const TeacherMessages = () => {
  return (
    <div>TeacherMessages</div>
  )
}

export default TeacherMessages